import {isMaster} from '../../functions/permission';
import * as css from './MasterPixel.css';
import React, {useState} from 'react';
import {TICK_DOMAIN_MY} from '../../config/config';
import readCookie from '../../library/readCookie';
import {useSelector} from 'react-redux';
import Table from '../newTable/Table';

import {getMasterPixelLinks} from '../../pages/appPlus/config/masterPixelLinks';

export interface IframeModalProps {
    isOpen: boolean;
    onClose: () => void;
    url: string;
}

export const IframeModal: React.FC<IframeModalProps> = ({isOpen, onClose, url}) => {
    const [isLoading, setIsLoading] = useState(true);

    if(!isOpen) return null;

    return (
        <css.ModalOverlay onClick={onClose}>
            <css.ModalContent onClick={e => e.stopPropagation()}>
                <css.CloseButton onClick={onClose}>×</css.CloseButton>
                {isLoading && <css.Loader />}
                <css.StyledIframe
                    src={url}
                    title="Content"
                    onLoad={() => setIsLoading(false)}
                    style={{opacity: isLoading ? 0 : 1}}
                />
            </css.ModalContent>
        </css.ModalOverlay>
    );
};

function MasterPixel() {
    if(!isMaster()) {
        return null;
    }
    const [selectedUrl, setSelectedUrl] = useState<string>('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const title = 'מאסטר הפיקסלים';
    const search={
        onSearch: (val: React.SetStateAction<string>) => setSearchTerm(val),
        onSearchEnd:() => setSearchTerm(''),
        searchState:{
            setIsSearchState: () => {},
            isSearchState: true
        },

    };
    const tickchakToken = readCookie('tickchak_user_local');
    const uid = useSelector((s:any) => s.user?.uid);
    const stupidLinks = getMasterPixelLinks(TICK_DOMAIN_MY, tickchakToken, uid);

    const handleLinkClick = (link: string) => {
        setSelectedUrl(link);
        setIsModalOpen(true);
    };

    const filteredLinks = stupidLinks.filter(link =>
        link.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const optionsList = filteredLinks.map(item => {
        return {
            text: item.title,
            link: item.link
        };
    });

    return (
        <>
            <Table
                list={optionsList?.map((item, index) => ({
                    comp: LinkRow,
                    props: {
                        ...item,
                        handleLinkClick
                    },
                    key: `link-${index}`,
                }))}
                searchProps={search}
                checked={undefined}
                buttonsChildren={undefined}
                title={title}
            />
            <IframeModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                url={selectedUrl}
            />
        </>
    );
}

function LinkRow(item: { index: number; handleLinkClick: any; text: string; link: string; }) {
    const {index, handleLinkClick, text, link} = item;
    const clickLink = link ? handleLinkClick : () => {};
    return (
        <css.Card key={index} onClick={() => clickLink(link)} className={link ? '' : 'title'}>
            {text}
            {link && <css.ExternalLinkIcon
                onClick={(e) => {
                    e.stopPropagation();
                    window.open(link, '_blank');
                }}
            />}

        </css.Card>
    );
}

export default MasterPixel;